module.exports = __webpack_public_path__ + "static/media/crossIcon.1d5b6a84.svg";